import {API_BASE_URL,WEB_SOCKET_BASE_URL} from './config';

// Generate magic link
export const generateMagicLink = async (email) => {
    try {
        const response = await fetch(`${API_BASE_URL}/generate-magic-link?email=${encodeURIComponent(email)}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.detail || 'Failed to generate magic link');
        }

        return await response.json();
    } catch (error) {
        console.error('Error generating magic link:', error);
        throw error;
    }
};




export const fetchUsers = async () => {
    try {
        const response = await fetch(`${API_BASE_URL}/users`);
        if (!response.ok) {
            throw new Error(`Error fetching users: ${response.statusText}`);
        }
        return await response.json();
    } catch (error) {
        console.error("Error fetching users:", error);
    }
};

export const changeUserRole = async (email, newRole) => {
    try {
        const is_admin = newRole === "Admin";
        const response = await fetch(`${API_BASE_URL}/change-role?email=${email}&is_admin=${is_admin}`, {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.detail || `Error changing role: ${response.statusText}`);
        }

        return "Role updated successfully.";
    } catch (error) {
        console.error("Error changing role:", error);
        throw error;
    }
};


export const ProcessOrder = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/process-order/}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json", 
        },
        body: JSON.stringify({ }),
      });
  
      if (response.ok) {
      } else {
        console.error("Error starting process:", response.statusText);
      }
    } catch (error) {
      console.error("Error starting process:", error);
    }
};

export const RescoringRun = async (builder_name,timestamp) => {
    try {
        
      const response = await fetch(`${API_BASE_URL}/call-rescoring/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json", 
        },
        body: JSON.stringify({ builder_name,timestamp }),
      });
  
      if (response.ok) {
        return { started: true };
      }
      // 409: another self-evaluation or rescoring is running; message says which.
      const errorData = await response.json();
      return { started: false, message: errorData.message || response.statusText };
    } catch (error) {
      console.error("Error starting process:", error);
      return { started: false, message: error.message };
    }
};

export const TestWebSocketLongRun = async (builder_name,timestamp,result,authToken) => {
    try {
      const response = await fetch(`${API_BASE_URL}/call-compiler/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json", 
        },
        body: JSON.stringify({ builder_name,timestamp,result,authToken}),
      });
  
      if (response.ok) {
      } else {
        console.error("Error starting process:", response.statusText);
      }
    } catch (error) {
      console.error("Error starting process:", error);
    }
};

export const OrdersListingRun = async (files, userId) => {
    if (!files || files.some(file => file.type !== 'application/pdf')) {
      throw new Error('Only PDF files are accepted.');
    }
  
    const formData = new FormData();
    formData.append('user_id', userId);
  
    files.forEach(file => {
        const extension = file.name.split('.').pop(); // Get the file extension
        const baseName = file.name.replace(/\.[^/.]+$/, ''); // Remove extension
        // Remove all special characters and keep only alphanumeric
        const cleanName = baseName.replace(/[^a-zA-Z0-9]/g, '');
        const truncatedName = cleanName.slice(-20); // Keep only the last 20 characters
        const newFileName = `${truncatedName}.${extension}`; // Construct the new filename
      
        // Create a new File object with the modified name
        const renamedFile = new File([file], newFileName, { type: file.type });
      
        formData.append('files', renamedFile);
      });
      
  
    try {
      const response = await fetch(`${API_BASE_URL}/process-file/`, {
        method: 'POST',
        body: formData,
      });
  
      const contentType = response.headers.get('content-type') || '';

      if (!response.ok) {
        let errorMessage = `Error: ${response.status}`;
        if (contentType.includes('application/json')) {
          try {
            const errorDetail = await response.json();
            const detail = errorDetail?.message || errorDetail?.detail || response.statusText;
            errorMessage = `${errorMessage} - ${detail}`;
            if (errorDetail?.trace) {
              const traceSnippet = String(errorDetail.trace).slice(0, 1000);
              errorMessage += `\nTrace:\n${traceSnippet}`;
            }
          } catch (_) {
            // fall through to text
            const text = await response.text();
            if (text) errorMessage = `${errorMessage} - ${text.slice(0, 500)}`;
          }
        } else {
          const text = await response.text();
          if (text) errorMessage = `${errorMessage} - ${text.slice(0, 500)}`;
        }
        throw new Error(errorMessage);
      }
  
      if (contentType.includes('application/json')) {
        try {
          const data = await response.json();
          return data;
        } catch (_) {
          // If server returned invalid JSON, fall back to empty
          return null;
        }
      }

      // Non-JSON success (e.g., empty body)
      return null;
    } catch (error) {
      throw new Error(`File upload failed: ${error.message}`);
    }
};
  
export function setupWebSocket(onMessage) {
    const socket = new WebSocket('ws://localhost:8400/ws');
  
    socket.onopen = () => console.log('WebSocket connection established.');
    socket.onmessage = event => {
      const message = JSON.parse(event.data);
      onMessage(message);
    };
    socket.onclose = () => console.log('WebSocket connection closed.');
    socket.onerror = error => console.error('WebSocket error:', error);
  
    return socket;
}

export const Scoring = async (builder_name,specific_result,timestamp) => {
    try {
      const response = await fetch(`${API_BASE_URL}/call-scoring/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json", // Specify that you're sending JSON data
        },
        body: JSON.stringify({ builder_name,specific_result,timestamp }),
      });
  
      if (response.ok) {
      } else {
        console.error("Error starting process:", response.statusText);
      }
    } catch (error) {
      console.error("Error starting process:", error);
    }
};

export const changeUserStatus = async (email, status) => {
    try {
        const response = await fetch(`${API_BASE_URL}/change-status?email=${email}&status=${!status}`, {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
        });

        if (!response.ok) {
            throw new Error(`Error updating user: ${response.statusText}`);
        }

        return "User status updated successfully.";
    } catch (error) {
        console.error("Error updating user status:", error);
        throw error;
    }
};

export const generateOtp = async (email) => {
    try {
        const response = await fetch(`${API_BASE_URL}/generate-otp?email=${email}`, {
            method: 'GET',
            headers: {'Content-Type': 'application/json'},
        });

        const result = await response.json();

        if (!response.ok) {
            const message = typeof result.detail === 'string'
                ? result.detail
                : (result.detail && result.detail.msg) || 'Failed to generate OTP';
            throw new Error(message);
        }

        return result; // Return OTP response for further use
    } catch (error) {
        console.error("Error generating OTP:", error);
        throw error;
    }
};

export const verifyOtp = async (email, userOtp) => {
    try {
        const response = await fetch(`${API_BASE_URL}/verify-otp?email=${email}&user_otp=${userOtp}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        const result = await response.json();

        if (!response.ok || result.msg !== 'SUCCESS') {
            throw new Error('OTP verification failed');
        }

        return result; // Contains auth_token and possibly other data
    } catch (error) {
        console.error('Error verifying OTP:', error);
        throw error;
    }
};

export const resendOtp = async (email) => {
    try {
        const response = await fetch(`${API_BASE_URL}/generate-otp?email=${email}`, {
            method: 'GET',
            headers: {'Content-Type': 'application/json'},
        });

        const result = await response.json();

        if (!response.ok) {
            const message = typeof result.detail === 'string'
                ? result.detail
                : (result.detail && result.detail.msg) || 'Failed to generate OTP';
            throw new Error(message);
        }

        return result; // Return result if needed for additional processing
    } catch (error) {
        console.error('Error resending OTP:', error);
        throw error;
    }
};


export const logoutUser = async (email) => {
    try {
        const response = await fetch(`${API_BASE_URL}/signout?email=${email}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error('Failed to log out.');
        }

        return response.json();
    } catch (error) {
        console.error('Error during logout:', error);
        throw error;
    }
};


export const addUser = async (new_user_email, is_admin, added_by) => {
    try {
        const response = await fetch(`${API_BASE_URL}/add-user?email=${new_user_email}&added_by=${added_by}&is_admin=${is_admin}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error('Failed to add user.');
        }

        return response.json();
    } catch (error) {
        console.error('Error during adding user:', error);
        throw error;
    }
};

export const addFile = async (file, fileContent, current_time, flag, authToken, filename) => {
    try {
        const formData = new FormData();
        formData.append('file', file);  // Append the actual file
        formData.append('fileContent', JSON.stringify(fileContent));  // Convert YAML dict to JSON string
        formData.append('timestamp', current_time);
        formData.append('flag', flag);
        formData.append('authToken', authToken);
        formData.append('filename', filename);

        const response = await fetch(`${API_BASE_URL}/add_file`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',  // Do NOT set 'Content-Type' manually; Fetch will handle it
            },
            body: formData,
        });

        if (!response.ok) {
            let errorMessage = 'An error occurred while adding the file.';
            
            try {
                // Try to parse the error response from the server
                const errorData = await response.json();
                if (errorData.detail) {
                    errorMessage = errorData.detail;
                } else if (errorData.message) {
                    errorMessage = errorData.message;
                } else if (errorData.error) {
                    errorMessage = errorData.error;
                }
            } catch (parseError) {
                // If response is not JSON, try to get text
                try {
                    const errorText = await response.text();
                    if (errorText) {
                        errorMessage = errorText;
                    }
                } catch (textError) {
                    // If all else fails, use status-based message
                    switch (response.status) {
                        case 400:
                            errorMessage = 'Bad request. Please check the file format and content.';
                            break;
                        case 401:
                            errorMessage = 'Unauthorized. Please check your authentication token.';
                            break;
                        case 403:
                            errorMessage = 'Forbidden. You do not have permission to add this file.';
                            break;
                        case 413:
                            errorMessage = 'File too large. Please reduce the file size.';
                            break;
                        case 415:
                            errorMessage = 'Unsupported file type. Please check the file format.';
                            break;
                        case 422:
                            errorMessage = 'Invalid file content. Please check the file syntax and structure.';
                            break;
                        case 500:
                            errorMessage = 'Server error. Please try again later.';
                            break;
                        default:
                            errorMessage = `Server returned status ${response.status}: ${response.statusText}`;
                    }
                }
            }
            
            throw new Error(errorMessage);
        }

        return response.json();
    } catch (error) {
        // If it's already our custom error, re-throw it
        if (error.message && !error.message.includes('fetch')) {
            console.error('Error adding file:', error.message);
            throw error;
        }
        
        // Handle network errors or other fetch-related errors
        console.error('Network or fetch error while adding file:', error);
        throw new Error('Network error. Please check your connection and try again.');
    }
};


export const compare_old_version = async (builder_name) => {
    try {
        
        const response = await fetch(`${API_BASE_URL}/compare_old_version?builder_name=${builder_name}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error('Failed to compare old version');
        }

        return response.json();
    } catch (error) {
        console.error('Error during compare old version', error);
        throw error;
    }
};
export const compare_files = async (timestamp,filename, modified) => {
    try {
        
        const response = await fetch(`${API_BASE_URL}/compare_files?timestamp=${timestamp}&filename=${filename}&modified=${modified}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error('Failed to compare old version');
        }

        return response.json();
    } catch (error) {
        console.error('Error during compare old version', error);
        throw error;
    }
};
export const change_status = async (builder_name,timestamp,status) => {
    try {
        const json_data = {'builder_name':builder_name,'timestamp':timestamp,'status':status}
        
        const response = await fetch(`${API_BASE_URL}/change_status`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(json_data),
        });

        if (!response.ok) {
            throw new Error('Failed to add user.');
        }

        return response.json();
    } catch (error) {
        console.error('Error during adding user:', error);
        throw error;
    }
};

export const deleteFile = async (builder_name,timestamp) => {
    try {
        const json_data = {'builder_name':builder_name,'timestamp':timestamp}
        
        const response = await fetch(`${API_BASE_URL}/delete_file`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(json_data),
        });

        if (!response.ok) {
            throw new Error('Failed to add user.');
        }

        return response.json();
    } catch (error) {
        console.error('Error during adding user:', error);
        throw error;
    }
};

export const retrieve_all_builders = async () => {

    try {
        const response = await fetch(`${API_BASE_URL}/retrieve_all_builders`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error('Failed to add user.');
        }

        return response.json();
    } catch (error) {
        console.error('Error during adding user:', error);
        throw error;
    }
};

export const retrieve_builder_wise = async (builder_name,timestamp) => {
    try {
        const response = await fetch(`${API_BASE_URL}/retrieve_builder_wise?builder_name=${builder_name}&timestamp=${timestamp}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error('Failed to retreive rules.');
        }
        return response.blob();
    } catch (error) {
        console.error('Error during retreiving rules:', error);
        throw error;
    }
};


export const retrieve_old_files = async () => {
    try {
        const response = await fetch(`${API_BASE_URL}/retrieve_old_files`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error('Failed to retrieve old files.');
        }

        return response.json();
    } catch (error) {
        console.error('Error during retrieve old files:', error);
        throw error;
    }
};

export const addTestCase = async (batchName,arg_description ,fileNames, pdfData) => {
    try {
        const response = await fetch(`${API_BASE_URL}self_eval_test_cases_api/test-case/add`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                batch_name: batchName,
                description:arg_description,
                file_names: fileNames,
                pdf_data: pdfData,
            }),
        });

        if (!response.ok) {
            throw new Error(`Error adding/updating test case: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error("Error adding/updating test case:", error);
        throw error;
    }
};



export const getTestCase = async (testCaseName) => {
    try {
        const response = await fetch(`${API_BASE_URL}self_eval_test_cases_api/test-case/${testCaseName}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`Error fetching test case: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error("Error fetching test case:", error);
        throw error;
    }
};


export const add_order_document = async (files) => {
    try {
        const response = await fetch(`${API_BASE_URL}/process-file/`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(files),
        });
        if (!response.ok) {
            throw new Error(`Error adding file: ${response.statusText}`);
        }

        return response.json();
    } catch (error) {
        console.error("Error adding file:", error);
        throw error;
    }
};

// Starts a full self-evaluation (every builder). Returns {started, message}; started is false
// with the server's message when another self-evaluation or rescoring is already running.
export const start_evaluation = async () => {
    const response = await fetch(`${API_BASE_URL}/call_self_evaluation/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id: localStorage.getItem('loggedInUserEmail') || 'test' }),
    });
    if (response.ok) {
        return { started: true };
    }
    const errorData = await response.json();
    return { started: false, message: errorData.message || response.statusText };
};


export const retrieve_score_data = async (filters) => {
    const commaSeparatedString = filters.join(', ');

    try {
        const response = await fetch(`${API_BASE_URL}/retrieve_score_data?filters=${encodeURIComponent(commaSeparatedString)}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            }
        });
        if (!response.ok) {
            throw new Error(`Error adding file: ${response.statusText}`);
        }
        return await response.text();
    } catch (error) {
        console.error("Error adding file:", error);
        throw error;
    }
};


export const start_avg_score_data = async (filters) => {
    const commaSeparatedString = filters.join(', ');
    try {
        const response = await fetch(`${API_BASE_URL}/call_avg_score_data?filters=${encodeURIComponent(commaSeparatedString)}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            }
        });
        if (!response.ok) {
            throw new Error(`Error adding file: ${response.statusText}`);
        }
        return await response.text();
    } catch (error) {
        console.error("Error adding file:", error);
        throw error;
    }
};



// Verify magic link token
export const verifyToken = async (email, token) => {
    try {
        const response = await fetch(`${API_BASE_URL}/verify-token?email=${encodeURIComponent(email)}&token=${encodeURIComponent(token)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.detail || 'Failed to verify token.');
        }

        const result = await response.json();
        return result; // Contains the verification status and message
    } catch (error) {
        console.error('Error verifying token:', error);
        throw error;
    }
};


export const retrieve_all_batches = async () => {
    try {
        const response = await fetch(`${API_BASE_URL}/get-batches`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        });


        return response.json();
    } catch (error) {
        console.error('Error during adding user:', error);
    }
}

export const sendtorfms = async (batch_name,builder_name,manual_corrections) => {
    
    
    
    const json_data = {
        batch_name: batch_name,
        builder_name: builder_name,
        manual_corrections:manual_corrections
    };

    try {
        const response = await fetch(`${API_BASE_URL}/sendtorfms?batch_name=${batch_name}&builder_name=${builder_name}&manual_corrections=${manual_corrections}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json' // Ensure content type is set
            }

        });
        if (!response.ok) {
            // Try to read JSON error body to extract meaningful message
            let errorText = `Error sending to RFMS: ${response.status} - ${response.statusText}`;
            try {
                const data = await response.json();
                const detailed = data?.detail || data?.message;
                if (detailed) {
                    errorText = detailed;
                }
            } catch (_) {
                // ignore JSON parsing errors and keep fallback text
            }
            throw new Error(errorText);
        }

        const result = await response.json(); // Await the JSON response
        return result; // Return the full response object which may contain removed_products
    } catch (error) {
        console.error("Error sending to RFMS:", error);
        throw error; // Rethrow the error for further handling if needed
    }
};

export const filter_dashboard_data = async (filters) => {
    const commaSeparatedString = filters.join(', ');

    try {
        const response = await fetch(`${API_BASE_URL}/call_dashboard?filters=${encodeURIComponent(commaSeparatedString)}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            }
        });
        if (!response.ok) {
            throw new Error(`Error adding file: ${response.statusText}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error adding file:", error);
        throw error;
    }
};

export const retrieveOrderItems = async (batch_name,po_number) => {
    // Replace with your actual base URL
    const baseUrl = `${API_BASE_URL}/retrieve_order_items`;

    try {
        const response = await fetch(`${baseUrl}?batch_name=${batch_name}&po_number=${po_number}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        return data; // This is the data returned from your API
    } catch (error) {
        console.error('Error fetching order items:', error);
        throw error; // Re-throw the error to handle it in calling code
    }
};
export const retrieveOrderLineItems = async (batch_name,po_number) => {
    // Replace with your actual base URL
    const baseUrl = `${API_BASE_URL}/retrieve_order_line_items`;

    try {
        const response = await fetch(`${baseUrl}?batch_name=${batch_name}&po_number=${po_number}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        return data; // This is the data returned from your API
    } catch (error) {
        console.error('Error fetching order items:', error);
        throw error; // Re-throw the error to handle it in calling code
    }
};
export const update_batch_status_and_action = async (batch_name) => {
    // Replace with your actual base URL
    const baseUrl = `${API_BASE_URL}/update-batch-status-and-action`;

    try {
        const response = await fetch(`${baseUrl}?batch_name=${batch_name}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        return data; // This is the data returned from your API
    } catch (error) {
        console.error('Error fetching order items:', error);
        throw error; // Re-throw the error to handle it in calling code
    }
};

export const retrievePO = async (batch_name) => {
    // Replace with your actual base URL
    const baseUrl = `${API_BASE_URL}/retrieve_PO_number`;

    try {
        const response = await fetch(`${baseUrl}?batch_name=${batch_name}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        return data; // This is the data returned from your API
    } catch (error) {
        console.error('Error fetching order items:', error);
        throw error; // Re-throw the error to handle it in calling code
    }
};
export const retrievePONumber= async (batch_name,order_type) => {
    // Replace with your actual base URL
    const baseUrl = `${API_BASE_URL}/retrieve_PO_number_orderType`;

    try {
        const response = await fetch(`${baseUrl}?batch_name=${batch_name}&order_type=${encodeURIComponent(order_type)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        return data; // This is the data returned from your API
    } catch (error) {
        console.error('Error fetching order items:', error);
        throw error; // Re-throw the error to handle it in calling code
    }
};

export const deleteBatch = async (po_number) => {
    try {
        const response = await fetch(`${API_BASE_URL}/delete_batch/${po_number}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`Error deleting test case: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error("Error deleting test case:", error);
        throw error;
    }

};
export async function editSoldTo(address1,customerId, customerType,firstName,lastName,postalCode,state,city,county,email,phone1,salesman1) {
    const url = `${API_BASE_URL}/edit-sold-to`; // Replace with the full API URL if needed
        const payload = {
            address1: address1,
            customer_id: customerId,
            customer_type: customerType ,
            first_name: firstName ,
            last_name: lastName ,
            postal_code: postalCode,
            state: state ,
            city: city ,
            county: county,
            email: email,
            phone1: phone1,
            salesman1: salesman1,
        };
    
        try {
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            });
    
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
    
            const result = await response.json();
            return result;
        } catch (error) {
            console.error("Error updating sold-to table:", error);
            throw error;
        }
    }

export async function editShipTo(
        batchName,
        firstName,
        lastName,
        address1,
        address2,
        state,
        city,
        postalCode,
        county
    ) {
        const url = `${API_BASE_URL}/edit-ship-to`; // Replace with the full API URL if needed
    
        const payload = {
            batch_name: batchName,
            first_name: firstName,
            last_name: lastName,
            address1: address1,
            address2: address2,
            state: state,
            city: city,
            postal_code: postalCode,
            county: county,
        };
    
        try {
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            });
    
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
    
            const result = await response.json();
            return result;
        } catch (error) {
            console.error("Error updating ship-to table:", error);
            throw error;
        }
    }
    export async function deleteLine(lineId, address, poNumber,order_type) {
        // Construct the URL with query parameters
        const url = `${API_BASE_URL}/delete_line?line_id=${encodeURIComponent(lineId)}&address=${encodeURIComponent(address)}&po_number=${encodeURIComponent(JSON.stringify(poNumber))}&order_type=${encodeURIComponent(order_type)}`;
        
        try {
            const response = await fetch(url, {
                method: "POST", // Adjust method if your backend expects POST for query params
                headers: {
                    "Content-Type": "application/json",
                },
            });
    
            if (!response.ok) {
                const errorDetails = await response.json();
                throw new Error(`Error ${response.status}: ${errorDetails.detail || "Failed to delete line."}`);
            }
    
            const result = await response.json();
            return result; // Expected to contain {"status": "success", "message": "Line deleted successfully"}
        } catch (error) {
            console.error("Failed to delete line:", error.message);
            throw error;
        }
    }
    export async function addNewLine(lineId, address, poNumber, order_type, productId = '', colorId = '', unitPrice = 0, styleName = '', colorName = '', billQuantity = 0, styleNumber = '', unit = '') {
        const url = `${API_BASE_URL}/insert_line?line_id=${encodeURIComponent(lineId)}&address=${encodeURIComponent(address)}&po_number=${encodeURIComponent(JSON.stringify(poNumber))}&order_type=${encodeURIComponent(order_type)}&product_id=${encodeURIComponent(productId)}&color_id=${encodeURIComponent(colorId)}&unit_price=${encodeURIComponent(unitPrice)}&style_name=${encodeURIComponent(styleName)}&color_name=${encodeURIComponent(colorName)}&bill_quantity=${encodeURIComponent(billQuantity)}&style_number=${encodeURIComponent(styleNumber)}&unit=${encodeURIComponent(unit)}`;
        try {
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
            });

            if (!response.ok) {
                const errorDetails = await response.json();
                throw new Error(`Error ${response.status}: ${errorDetails.detail || "Failed to insert line."}`);
            }

            const result = await response.json();
            return result;
        } catch (error) {
            console.error("Failed to insert line:", error.message);
            throw error;
        }
    }
    export async function editLines(orderArray,address,po_number) {
        for (const order of orderArray) {
            // Destructure order object to extract variables
            const { orderType, lineNumber, styleName, colorName, quantity, unitPrice, unit, notes, productId, colorId} = order;
    
            // Construct the URL with query parameters
            const url = `${API_BASE_URL}/edit-line?line_id=${lineNumber}&address=${encodeURIComponent(address)}&po_number=${encodeURIComponent(po_number)}&order_type=${encodeURIComponent(orderType)}&style_name=${encodeURIComponent(styleName)}&color_name=${encodeURIComponent(colorName)}&quantity=${quantity}&unit_price=${unitPrice}&unit=${encodeURIComponent(unit)}&notes=${encodeURIComponent(notes)}&product_id=${encodeURIComponent(productId ?? '')}&color_id=${encodeURIComponent(colorId ?? '')}`;
    
            try {
                // Make the backend call
                const response = await fetch(url, {
                    method: "POST", // Use GET since data is sent in the URL
                });
    
                // Handle the response
                if (response.ok) {
                    const result = await response.json();
                } else {
                    console.error(`Error processing order:`, response.status, response.statusText);
                }
            } catch (error) {
                console.error(`Failed to process order for lineNumber ${lineNumber}:`, error);
            }
        }
    }

    export async function editWorkOrderNotes(po_number, order_type, work_order_notes) {
        const url = `${API_BASE_URL}/edit-work-order-notes?po_number=${encodeURIComponent(po_number)}&order_type=${encodeURIComponent(order_type)}&work_order_notes=${encodeURIComponent(work_order_notes)}`;
        
        try {
            const response = await fetch(url, {
                method: "POST",
            });

            if (response.ok) {
                const result = await response.json();
                return result;
            } else {
                console.error(`Error updating work order notes:`, response.status, response.statusText);
                throw new Error(`Failed to update work order notes: ${response.statusText}`);
            }
        } catch (error) {
            console.error(`Failed to update work order notes:`, error);
            throw error;
        }
    }
    export async function sendLoggedInUserId(options = {}) {
        try {
            // Retrieve the logged-in user's email from localStorage
            const loggedInUserId = localStorage.getItem('authToken');
    
            if (!loggedInUserId) {
                throw new Error('No logged-in user id found in localStorage.');
            }
    
            // Prepare the request body and headers
            const body = JSON.stringify({ email: loggedInUserId });
            const headers = {
                'Content-Type': 'application/json',
                ...options.headers,
            };
    
            // Send the email to the backend
            const response = await fetch(`${API_BASE_URL}/getLoggedInId`, {
                method: 'POST',
                headers: headers,
                body: body,
                ...options,
            });
    
            // Check if the response is okay
            if (!response.ok) {
                throw new Error(`Failed to send user id: ${response.statusText}`);
            }
    
            return response.json(); // Parse the response as JSON
        } catch (error) {
            console.error('Error sending logged-in user id:', error.message);
            throw error;
        }
    }

    export const searchProducts = async (productDescription) => {
        try {
            const response = await fetch(`${API_BASE_URL}/search-product?product_description=${encodeURIComponent(productDescription)}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                }
            });
    
            if (!response.ok) {
                throw new Error(`Error fetching products: ${response.status} - ${response.statusText}`);
            }
    
            const result = await response.json();
            return result;
        } catch (error) {
            console.error("Error fetching products:", error);
            throw error; // Re-throw for higher-level handling if necessary

        }
    };

    export async function downloadDocuments(ship_to_address) {
        const url = `${API_BASE_URL}/download-documents`;
    
        try {
            // Make the backend call
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ ship_to_address }), // Pass the data in the body
            });
    
            if (response.ok) {
                // Handle the streaming response as a downloadable file
                const blob = await response.blob();
                const downloadUrl = window.URL.createObjectURL(blob);
    
                // Create a link element to trigger the download
                const link = document.createElement("a");
                link.href = downloadUrl;
                link.download = `${ship_to_address}_documents.zip`;
                link.click();
    
                // Clean up
                window.URL.revokeObjectURL(downloadUrl);
            } else {
                console.error(`Error downloading documents:`, response.status, response.statusText);
            }
        } catch (error) {
            console.error(`Failed to download documents for ${ship_to_address}:`, error);
        }
    }
    export async function add_test_case(batch_name) {  // Changed parameter name
        const url = `${API_BASE_URL}/add-test-case`;
        try {
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    batch_name: batch_name  // Match backend parameter name
                })
            });
    
            if (!response.ok) {
                let errorData;
                // Handle different response types
                const contentType = response.headers.get('content-type');
                if (contentType && contentType.includes('application/json')) {
                    errorData = await response.json();
                } else {
                    errorData = await response.text();
                }
                throw new Error(`Server error: ${response.status} - ${JSON.stringify(errorData)}`);
            }
    
            const result = await response.json();
            return result;
            
        } catch (error) {
            console.error(`Failed to add test case for ${batch_name}:`, error);
            throw error; // Re-throw to allow handling in the component
        }
    }
    export const getAllTestCases = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/test-cases/`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
    
            if (!response.ok) {
                throw new Error(`Error fetching test cases: ${response.statusText}`);
            }
    
            return await response.json();
        } catch (error) {
            console.error("Error fetching test cases:", error);
            throw error;
        }
    };

    export const getTestCaseAnswerKey = async (testCaseName) => {
        const response = await fetch(`${API_BASE_URL}/test-case-answer-key/${encodeURIComponent(testCaseName)}`);
        if (!response.ok) {
            throw new Error(`Error fetching answer key: ${response.statusText}`);
        }
        return response.json();
    };

    export const deleteTestCase = async (testCaseName) => {
        try {
            const response = await fetch(`${API_BASE_URL}/test-case-delete/${testCaseName}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
    
            if (!response.ok) {
                throw new Error(`Error deleting test case: ${response.statusText}`);
            }
    
            return await response.json();
        } catch (error) {
            console.error("Error deleting test case:", error);
            throw error;
        }
    };
    
    export const retrieve_batches = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/get-test-case-batches`, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            });
    
    
            return response.json();
        } catch (error) {
            console.error('Error during adding user:', error);
        }
    }
    export const retrieve_chart_data = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/call_chart_data`
                , {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            });
    
    
            return await  response.json();
        } catch (error) {
            console.error('Error during adding user:', error);
        }
    }
    export const retrieve_time_data = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/call_mean_time`
                , {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            });
            return await  response.json();
        } catch (error) {
            console.error('Error during adding user:', error);
        }
    }



    export const retreive_failures = async (builder_time_stamp, builder_name) => {
        const url = `${API_BASE_URL}/get_failures?builder_time_stamp=${encodeURIComponent(builder_time_stamp)}&builder_name=${encodeURIComponent(builder_name)}`;
        try {
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            });
            return await response.json();
        } catch (error) {
            console.error('Error during fetching failures:', error);
        }
    } 

    export const get_builders = async () => {
        const url = `${API_BASE_URL}/get_builders`;
        try {
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            });
            return await response.json();
        } catch (error) {
            console.error('Error during fetching failures:', error);
        }
    } 
    export const compare_snapshots_and_store = async (batchName) => {
        const url = `${API_BASE_URL}/compare_snapshots_and_store?batch_name=${encodeURIComponent(batchName)}`;
        try {
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            });
            return await response.json();
        } catch (error) {
            console.error('Error during fetching failures:', error);
        }
    } 
    export const get_median_corrections_last_month = async () => {
        const url = `${API_BASE_URL}/get_median_corrections_last_month`;
        try {
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            });
            return await response.json();
        } catch (error) {
            console.error('Error during fetching failures:', error);
        }
    } 

    export const retrieveGrandTotal = async (batch_name, po_number) => {
        try {
            const response = await fetch(`${API_BASE_URL}/retrieve_grand_total?batch_name=${encodeURIComponent(batch_name)}&po_number=${encodeURIComponent(po_number)}`, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const data = await response.json();
            return data;
        } catch (error) {
            console.error('Error fetching grand total:', error);
            throw error;
        }
    }

    export const retrieveAllGrandTotals = async (batch_name, po_numbers) => {
        try {
            const response = await fetch(`${API_BASE_URL}/retrieve_all_grand_totals?batch_name=${encodeURIComponent(batch_name)}&po_numbers=${encodeURIComponent(po_numbers)}`, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const data = await response.json();
            return data;
        } catch (error) {
            console.error('Error fetching all grand totals:', error);
            throw error;
        }
    } 

    export const retrieveWorkOrderNotes = async (batch_name) => {
        try {
            const response = await fetch(`${API_BASE_URL}/retrieve_work_order_notes?batch_name=${encodeURIComponent(batch_name)}`, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const data = await response.json();
            return data;
        } catch (error) {
            console.error('Error fetching work order notes:', error);
            throw error;
        }
    }

    export const updatePONumber = async (batch_name, new_po_number) => {
        try {
            const response = await fetch(`${API_BASE_URL}/update-po-number/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                },
                body: JSON.stringify({
                    batch_name: batch_name,
                    new_po_number: new_po_number
                }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const data = await response.json();
            return data;
        } catch (error) {
            console.error('Error updating PO number:', error);
            throw error;
        }
    }
    // Admin Settings: which LLM provider the app uses (Azure OpenAI or OpenAI) and OpenAI's models
    export const getLlmSettings = async () => {
        const response = await fetch(`${API_BASE_URL}/llm-settings`);
        if (!response.ok) {
            throw new Error(`Error fetching LLM settings: ${response.statusText}`);
        }
        return response.json();
    };

    export const getOpenAiModels = async () => {
        const response = await fetch(`${API_BASE_URL}/llm-settings/openai-models`);
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || errorData.detail || `Error fetching OpenAI models: ${response.statusText}`);
        }
        return response.json();
    };

    // openaiChoices: {CONNECTION: {model, temperature, reasoning_effort}}; null = not sent
    export const saveLlmSettings = async (provider, openaiChoices) => {
        const response = await fetch(`${API_BASE_URL}/llm-settings`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                email: localStorage.getItem('loggedInUserEmail'),
                provider,
                openai: openaiChoices,
            }),
        });
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || errorData.detail || `Error saving LLM settings: ${response.statusText}`);
        }
        return response.json();
    };

    // Whether a self-evaluation or rescoring is really running (a run that died counts as not)
    export const getSelfEvaluationStatus = async () => {
        const response = await fetch(`${API_BASE_URL}/self-evaluation-status`);
        if (!response.ok) {
            throw new Error(`Error fetching self evaluation status: ${response.statusText}`);
        }
        return response.json();
    };

    // Rule sets compiling or scoring right now, with rules compiled / POs scored so far
    export const getRuleProgress = async () => {
        const response = await fetch(`${API_BASE_URL}/rule-progress`);
        if (!response.ok) {
            throw new Error(`Error fetching rule progress: ${response.statusText}`);
        }
        return response.json();
    };
